module.exports = __webpack_public_path__ + "img/residential.2d21155b.svg";